export enum BookingAllowedStatus {
    UNSET = 0,
    ACTIVE_ALL = 1,
    ACTIVE_SCREEN = 2,
    ACTIVE_SIGNUP = 3,
    INACTIVE = 4,
}
